import { useRef, useState } from "react";

import { Form } from "react-bootstrap";

import { PrimaryCta } from "components/Buttons";
import { TextField } from "components/Fields";
import { generateRandom6AlphaNumeric } from "helpers";
import { api } from "helpers/api";
import useUser from "hooks/useUser";
import { MSMProfile, QuickWidgetResult } from "model/object/quick-widget-result";
import Image from "next/image";
import msmlogo from "../../../public/MoneySuperMarketTextDark.png";

type QWPartnerValuationSectionProps = { type?: string; result?: QuickWidgetResult; profile: MSMProfile; source: string; reg: string; variant?: string };

export default function QWPartnerValuationSection({ type = "", result, profile, source, reg, variant = "partner" }: QWPartnerValuationSectionProps) {
	const [termsAndConditions, setTermsAndConditions] = useState(false);
	const [email, setEmail] = useState("");
	const validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	const [isSubmitting, setSubmitting] = useState(false);
	const linkRef = useRef() as any;
	const user = useUser();
	const aplhaNums = generateRandom6AlphaNumeric();

	const handleSubmit = async () => {
		setSubmitting(true);
		linkRef?.current?.click();
		try {
			await api.post(
				"/msm/marketing",
				{ ...profile, email, marketingConfirmation: termsAndConditions, refId: aplhaNums },
				{
					headers: {
						source,
					},
				}
			);
		} catch (error) {
			console.error(error);
		}

		setSubmitting(false);
	};

	return (
		<>
			<section className={`flex flex-col items-center px-3 pt-[10px]`}>
				<div
					className={`relative !z-10 -mt-[1rem] flex w-[70vw] items-center justify-center gap-16 rounded-lg ${
						variant === "base" ? "bg-white" : "bg-[#132237]"
					} px-[12rem] py-2 !pt-[25px] !text-sm shadow-md mobileL:w-[90vw] tablet:gap-4 laptop:px-5`}
				>
					<div className="flex flex-col text-center">
						<p>Lower Value</p>
						<p className="text-[14px]">{result?.lower ? `£ ${result?.lower}` : "No data"}</p>
					</div>
					<div className="flex flex-col text-center">
						<p>Upper Value</p>
						<p className="text-[14px]">{result?.upper ? `£ ${result?.upper}` : "No data"}</p>
					</div>
				</div>
			</section>
			<div className="align-items-center  mt-[10px] items-center justify-center px-3 pb-[15px]  text-center text-sm">
				{variant !== "base" && (
					<div className="relative z-40 mx-auto -mb-6 w-[15rem] rounded-lg bg-white px-6 py-2 pb-1">
						<Image src={msmlogo} alt="MSM Logo" width={160} height={25} />
					</div>
				)}
				<div className={`relative z-10 rounded-lg shadow-md ${variant === "base" ? "bg-white !text-indigo" : "bg-[#132237] pt-[35px]"} px-4 py-2.5`}>
					{variant === "base" ? (
						<p className="text-[10px]">
							To get your insurance quotes, powered by MoneySuperMarket, click the button and add a few more details 5 peices of information to get your Car Insurance
							quote in less than a min
						</p>
					) : (
						<p className="text-[10px]">To get your insurance quotes, powered by MoneySuperMarket, click the button and add a few more details</p>
					)}
					<Form.Group className="align-items-center left-0 right-0 mx-auto mt-2 flex max-w-[20rem] flex-col">
						<TextField
							name={"email"}
							className="placeholder:font-bold placeholder:opacity-50"
							type={"email"}
							placeholder="Enter your email address"
							value={email}
							handleChange={e => {
								setEmail(e.target.value);
							}}
							required
						/>
					</Form.Group>
					<Form.Group className="align-items-center left-0 right-0 mx-auto mb-6 mt-2 flex max-w-[30rem] text-center text-xs">
						{/* <Form.Check
							id="termsAndConditions"
							name="termsAndConditions"
							type="checkbox"
							className="text-[12px]"
							checked={termsAndConditions}
							onChange={() => setTermsAndConditions(t => !t)}
							required
						/>*/}
						<p className={`text-start !text-[0.45rem] ${variant === "base" ? "text-indigo" : "text-white"} `}>
							Check this box to enter the draw to win back your insurance premium (max £1,000) and agree to the
							<a href="https://carcloudcommunity.co.uk/insurance-prize-draw" target="_blank" rel="noreferrer">
								<b className={`font-bold  ${variant === "base" ? "text-indigo" : "text-white"} underline`}> Terms & Conditions </b>
							</a>
							.
						</p>
					</Form.Group>
					<div className="mx-auto mt-2 rounded-3xl ">
						<PrimaryCta
							text="Get Quotes"
							className="mx-auto !text-[14px] tablet:!w-[70vw]"
							hasArrowRight
							disabled={!email.match(validEmail)}
							onClick={handleSubmit}
							isSubmitting={isSubmitting}
						/>
					</div>
				</div>

				<Form.Group className="align-items-center left-0 right-0 mx-auto mt-1 flex max-w-[30rem] text-xs">
					<p className={`text-left !text-[8px] font-medium ${variant === "base" ? "text-indigo" : "text-white"}`}>
						*The quote range shown above is an indicative quote based on the subset of information you have entered. It compares the information you entered to a
						database of similar attributes to return an indicative quote range. The figures presented are drawn from a dataset last updated in October 2024. You will
						need to complete the full question set to get an accurate insurance price
						<a href="https://carcloud.motor.moneysupermarket.insure/privacy-policy" target="_blank" rel="noreferrer">
							<b className={`font-bold  ${variant === "base" ? "text-indigo" : "text-white"}`}> Privacy policy</b>
						</a>
					</p>
				</Form.Group>
				<a
					href={email.match(validEmail) ? `https://carcloud.motor.moneysupermarket.insure/?ref1=${aplhaNums}${source && `&ref2=${source}`}${reg && `#reg=${reg}`}` : "/"}
					target="_blank"
					rel="noopener noreferrer"
					ref={linkRef as any}
					className="hidden w-auto"
				>
					Tab
				</a>
			</div>
		</>
	);
}
